/* Custom Announcement Bar — PERSIAN Store
   Vanilla JS, no dependencies. Handles multiple bars on a page safely
   and re-initializes correctly inside the Shopify theme editor. */

(function () {
  'use strict';

  var instances = {};

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initBar(root) {
    if (!root || root.dataset.pcsInitialized === 'true') return;
    root.dataset.pcsInitialized = 'true';

    var sectionId = root.dataset.sectionId;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pcs-slide]'));
    var prevBtn = root.querySelector('[data-pcs-prev]');
    var nextBtn = root.querySelector('[data-pcs-next]');
    var closeBtn = root.querySelector('[data-pcs-close]');
    var rememberKey = root.dataset.rememberKey;
    var autoplay = root.dataset.autoplay === 'true' && slides.length > 1 && !prefersReducedMotion();
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var timer = null;

    // Respect a prior dismissal on this browser.
    if (rememberKey) {
      try {
        if (window.localStorage.getItem(rememberKey) === 'true') {
          root.classList.add('is-dismissed');
        }
      } catch (e) { /* localStorage unavailable (private mode, etc.) — ignore */ }
    }

    function show(index) {
      if (!slides.length) return;
      var next = ((index % slides.length) + slides.length) % slides.length;
      if (next === current) return;
      slides[current].classList.remove('is-active');
      slides[next].classList.add('is-active');
      current = next;
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(function () { show(current + 1); }, speed);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(current - 1);
        start(); // reset the autoplay clock after a manual interaction
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(current + 1);
        start();
      });
    }

    // Pause on hover/focus so people can actually read + click a message.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        stop();
        root.classList.add('is-dismissed');
        if (rememberKey) {
          try { window.localStorage.setItem(rememberKey, 'true'); } catch (e) { /* ignore */ }
        }
      });
    }

    start();

    instances[sectionId] = { root: root, start: start, stop: stop, show: show, slides: slides };
  }

  function initAll(context) {
    var scope = context || document;
    var bars = scope.querySelectorAll('[data-pcs-announce-bar]');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  // Theme-editor support: re-init on section load, clean up on unload,
  // and jump to whichever block the merchant is currently editing.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-pcs-announce-bar]');
    var sectionId = root && root.dataset.sectionId;
    if (sectionId && instances[sectionId]) {
      instances[sectionId].stop();
      delete instances[sectionId];
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-pcs-announce-bar]');
    if (!root) return;
    var sectionId = root.dataset.sectionId;
    var inst = instances[sectionId];
    if (!inst) return;
    var index = inst.slides.findIndex(function (s) { return s.dataset.blockId === event.detail.blockId; });
    if (index > -1) {
      inst.stop();
      inst.show(index);
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest('[data-pcs-announce-bar]');
    if (!root) return;
    var inst = instances[root.dataset.sectionId];
    if (inst) inst.start();
  });
})();
